import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function CreditBalance({ fetchTransaction, fetchUser, setShowDeduct }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [reason, setReason] = useState('')

  const [amount, setAmount] = useState(0)

  async function updateDebt() {
    const data = {
      amount: amount,
      reason: reason,
    }
    if (amount < 1) {
      notify('warn', 'Input Amount')
      return
    }
    setCancelLoading(true)
    post(`admin/business/credit-balance/${id}`, data, null)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Balance Updated')
          setShowDeduct(false)
          fetchUser()
          fetchTransaction(1, 'all', 10)
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Credit User's Balance</h1>
        <p>Note: will increase the balance of this user..</p>
        <input
          type='number'
          min={1}
          placeholder='Enter Amount'
          onChange={(e) => setAmount(parseFloat(e.target.value))}
        />
        <textarea
          placeholder='Enter Reason'
          onChange={(e) => setReason(e.target.value)}
        ></textarea>
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowDeduct(false)}>Cancel</button>
            <button className='proceed' onClick={updateDebt}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CreditBalance
